import { Component, HostListener, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ROUTING_ESTADO_TRAMITE_PENSION } from "@constants/url.constant";
import { EstadoTramiteStepperService } from "../../services/estado-tramite-stepper.service";

@Component({
    selector: "app-estado-tramite-pension-stepper",
    templateUrl: "./estado-tramite-pension-stepper.component.html",
    styleUrls: ["./estado-tramite-pension-stepper.component.scss"],
    standalone: false
})
export class EstadoTramitePensionStepperComponent implements OnInit {
  step: number = 0;
  isResponsive: boolean = false;
  titleCurrentStepResponsive: string = "";
  currentStepResponsive: string = "";

  constructor(private readonly estadoTramiteStepper: EstadoTramiteStepperService, private readonly router: Router) { }

  ngOnInit(): void {
    this.isResponsive = window.innerWidth < 840;
    this.getCurrentStep();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Verificar si la URL actual es la que quieres redirigir
        if (event.url === '/pensions') {
          this.router.navigate(['/pensions/estado-tramite-pension']); // Redirecciona a la ruta base
        }
      }
    });
  }

  public steps: any[] = [
    {
      status: "pending",
      title: "Paso 1",
      subTitle: "Inicio trámite de pensión",
      path: ROUTING_ESTADO_TRAMITE_PENSION.INICIO,
      url: "/pensions/estado-tramite-pensiones/home",
    },
    {
      status: "pending",
      title: "Paso 2",
      subTitle: "Certificado de Saldos",
      path: ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_SALDOS,
      url: "/pensions/estado-tramite-pensiones/certificados-saldos",
    },
    {
      status: "pending",
      title: "Paso 3",
      subTitle: "Certificado de Ofertas SCOMP",         
      path: ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_OFERTAS,
      url: "/pensions/estado-tramite-pensiones/certificados-ofertas",
    },
    {
      status: "pending",
      title: "Paso 4",
      subTitle: "Modalidad de pensión",
      path: ROUTING_ESTADO_TRAMITE_PENSION.MODALIDAD_PENSION,
      url: "/pensions/estado-tramite-pensiones/modalidad-pension",
    },
    {
      status: "complete",
      title: "Paso 5",
      subTitle: "Pago de pensión",
      path: ROUTING_ESTADO_TRAMITE_PENSION.PAGO_PENSION,
      url: "/pensions/estado-tramite-pensiones/pago-pension",
    },
  ];

  getCurrentStep() {
    this.estadoTramiteStepper.stepCurrent.subscribe((response) => {
      this.step = response;
      const totalSteps = this.steps.length;
      let currentStepIndex = 1;
      for (const step of this.steps) {
        if (currentStepIndex < this.step) {
          step.status = "complete";
        } else if (currentStepIndex === this.step) {
          step.status = "current";
          this.titleCurrentStepResponsive = step.subTitle;
          this.currentStepResponsive = `Paso ${currentStepIndex} de ${totalSteps}`;
        } else {
          step.status = "pending";
        }
        currentStepIndex++;
      }
    });
  }

  calculateProgress(): number {
    const completedSteps = this.steps.filter(step => step.status === 'current' || step.status === 'complete').length;    
    return completedSteps / this.steps.length; // Retorna un valor entre 0 y 1
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = window.innerWidth < 840;
  }
}
